var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSw3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 9.37431C20.6458 9.37431 21.1705 8.8496 21.1705 8.20239V4.06158C21.1705 3.41436 20.6458 2.88965 19.9986 2.88965C19.3514 2.88965 18.8267 3.41436 18.8267 4.06158V8.20239C18.8267 8.8496 19.3514 9.37431 19.9986 9.37431Z",
    fill: "#FE7320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5349 11.3651C13.9925 11.8228 14.7345 11.8229 15.1922 11.3651C15.6499 10.9075 15.6499 10.1655 15.1922 9.7078L12.2643 6.77978C11.8067 6.3221 11.0646 6.3221 10.6069 6.77978C10.1493 7.23746 10.1493 7.97944 10.6069 8.43712L13.5349 11.3651Z",
    fill: "#FE7320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6336 11.7084C25.9335 11.7084 26.2335 11.5941 26.4622 11.3651L29.3902 8.43712C29.8479 7.97944 29.8479 7.23746 29.3902 6.77978C28.9326 6.3221 28.1906 6.3221 27.7329 6.77978L24.8049 9.7078C24.0645 10.4482 24.5989 11.7084 25.6336 11.7084Z",
    fill: "#FE7320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2356 24.7656L27.3675 15.5875C27.2146 15.0983 26.7614 14.7651 26.2489 14.7651H13.7483C13.2357 14.7651 12.7827 15.0983 12.6298 15.5875L9.7616 24.7656H30.2356Z",
    fill: "#FE7320"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2965 27.1094C35.8586 27.1094 25.4981 27.1094 23.9854 27.1094C20.9471 36.8316 21.1705 36.0581 21.1705 36.2482C21.1705 36.724 21.5562 37.1098 22.0321 37.1098H38.8002C39.647 37.1098 40.176 36.3242 39.9462 35.5883L37.2965 27.1094Z",
    fill: "#FE7320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7874 35.9913L16.0118 27.1094C14.4104 27.1094 4.10231 27.1094 2.70069 27.1094L0.0590037 35.5626C-0.193195 36.3696 0.397925 37.1098 1.1696 37.1098H17.9651C18.5459 37.1098 18.9606 36.5457 18.7874 35.9913Z",
    fill: "#FE7320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw3);
export default __webpack_public_path__ + "static/media/sw3.90526af3e95fae94ed5f4bfc730a7b0a.svg";
export { ForwardRef as ReactComponent };